import { Component, OnDestroy, OnInit, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalService } from 'app/shared/services/global.service';
import { MatIconModule } from '@angular/material/icon';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { fuseAnimations } from '@fuse/animations';

@Component({
    selector: 'offline-notification',
    template: `
        <div *ngIf="_service.isOffline()" class="offline-notification" @fadeIn>
            <mat-icon class="mr-2" [svgIcon]="'feather:wifi-off'"></mat-icon> Offline
            <tooltip [title]="'Cannot connect to the server.<br/>Please check your internet connection'" [color]="'text-white'" class="ml-2"></tooltip>
        </div>
        <div *ngIf="showConnected" class="online-notification" @fadeOut>
            <mat-icon class="mr-2" [svgIcon]="'feather:wifi'"></mat-icon> Online
        </div>
    `,
    styles: [`
        .offline-notification, .online-notification {
            @apply flex justify-center items-center w-40 text-white absolute mx-auto inset-x-0 top-2 border rounded shadow p-2 z-99 ;
            mat-icon { color: white; }
        }
        .offline-notification {
            @apply bg-red-500 ;
        }
        .online-notification {
            @apply bg-green-600 ;
        }
    `],
    animations: fuseAnimations,
    imports: [CommonModule, MatIconModule, TooltipComponent],
})
export class OfflineNotificationComponent implements OnInit, OnDestroy {

    protected _service = inject(GlobalService);

    // Initialised... Don't show "Online" notification until the user has been confirmed "Offline".
    initialised = false;
    showConnected = false;
    interval: any;

    private offlineInterval: number = 5;
    private onlineInterval: number = 60;

    constructor() {
        effect(() => {
            let online = this._service.isOnline();
            if (online === null) {
                return;
            }

            if (online === false && !this.initialised) {
                this.initialised = true;
            }

            if (online === true && this.initialised) {
                this.showConnected = true;
                // show "Connected" notification for 3 seconds
                setTimeout(() => this.showConnected = false, 3000);
            }

            this.setPingInterval(online ? this.onlineInterval : this.offlineInterval);
        });
    }

    ngOnInit(): void {
        this.setPingInterval(this.onlineInterval);
        this.doPing();
    }

    ngOnDestroy(): void {
        this.clearPingInterval();
    }

    clearPingInterval(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    setPingInterval(seconds: number) {
        // console.log('OfflineNotificationComponent.setPingInterval()', seconds);
        this.clearPingInterval();

        this.interval = setInterval(() => this.doPing(), seconds * 1000);
    }

    doPing() {
        // console.log('OfflineNotificationComponent.doPing()');
        this._service.verifyConnectivity().subscribe();
    }
}
